(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fsg-bundles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-fsg-bundle-form]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-bundle-status]');
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel;
    status.textContent = '';

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Bundle could not be added');
      window.location.assign(form.dataset.cartUrl);
    } catch (error) {
      status.textContent = form.dataset.errorLabel;
      button.disabled = false;
      button.textContent = button.dataset.defaultLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsg-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeHeroCarousel = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const previous = root.querySelector('[data-hero-previous]');
    const next = root.querySelector('[data-hero-next]');
    const toggle = root.querySelector('[data-hero-toggle]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayEnabled = root.dataset.autoplay === 'true';
    const interval = Number(root.dataset.interval) || 6000;
    let activeIndex = 0;
    let timer;
    let userPaused = false;
    let interactionPaused = false;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!autoplayEnabled || reducedMotion.matches || userPaused || interactionPaused || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    const restart = () => {
      stop();
      start();
    };

    previous?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      restart();
    });
    next?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      restart();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.index));
        restart();
      });
      dot.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        showSlide(activeIndex + direction);
        dots[activeIndex].focus();
        restart();
      });
    });
    toggle?.addEventListener('click', () => {
      userPaused = !userPaused;
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.textContent = userPaused ? root.dataset.playLabel : root.dataset.pauseLabel;
      restart();
    });

    root.addEventListener('mouseenter', () => {
      interactionPaused = true;
      stop();
    });
    root.addEventListener('mouseleave', () => {
      interactionPaused = false;
      start();
    });
    root.addEventListener('focusin', () => {
      interactionPaused = true;
      stop();
    });
    root.addEventListener('focusout', () => {
      window.requestAnimationFrame(() => {
        if (root.contains(document.activeElement)) return;
        interactionPaused = false;
        start();
      });
    });
    document.addEventListener('visibilitychange', restart);
    reducedMotion.addEventListener('change', restart);

    showSlide(0);
    start();
  };

  const initializeAllHeroCarousels = (scope = document) => {
    scope.querySelectorAll('[data-fsg-hero-carousel]').forEach(initializeHeroCarousel);
  };

  initializeAllHeroCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeAllHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsg-squzzle-clues"]) return;
  try {
    
  document.querySelectorAll('[data-squzzle-clues]').forEach(section => {
    const openClue = hash => {
      const clue = [...section.querySelectorAll('details[id]')].find(panel => '#' + panel.id === hash);
      if (clue) clue.open = true;
    };
    section.querySelector('.fsg-clues__index')?.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (link) openClue(link.getAttribute('href'));
    });
    window.addEventListener('hashchange', () => openClue(location.hash));
    openClue(location.hash);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.fsg-header__shop[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.fsg-header__shop[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-fsg-variant-selector]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.href);
  });

  } catch(e) { console.error(e); }
})();
})();
